export default "__VITE_ASSET__BMqwGPFM__"